<template>
  <div class="select-container row mx-1">
    <div class="w-75 d-flex align-items-center">
      <v-select
        v-model="selected_student_id"
        :options="studentsFormatted"
        :reduce="(student) => student.id"
        label="display_name"
        :placeholder="$t('evaluations.newEvaluations.selectStudent')"
        class="flex-grow-1 v-select-sm"
      >
        <template #option="option">
          <span
            v-if="
              evaluator_view &&
              actualTest &&
              startTest(option.id) &&
              !finishTest(option.id) &&
              !isPublichGradeStudent(option.id) &&
              !isDateAfterTest(actualTest.end_time)
            "
          >
            🟡
          </span>
          <span
            v-if="
              evaluator_view &&
              actualTest &&
              startTest(option.id) &&
              !finishTest(option.id) &&
              !isPublichGradeStudent(option.id) &&
              isDateAfterTest(actualTest.end_time)
            "
          >
            🟠
          </span>
          <span
            v-if="
              actualTest &&
              evaluator_view &&
              finishTest(option.id) &&
              !isPublichGradeStudent(option.id)
            "
          >
            🟢
          </span>
          <span
            v-if="
              actualTest && evaluator_view && isPublichGradeStudent(option.id)
            "
            class="checkmark"
          >
            📝
          </span>
          <span v-if="actualTest && evaluator_view && !startTest(option.id)">
            ❌
          </span>
          <span v-if="actualTest && evaluator_view && inGroup(option.id)">
            {{ getNameGroup(option.id) }}
            <span v-if="isLeaderStudent(option.id)">🚩 </span>
            -
          </span>
          {{ option.display_name }}
        </template>
        <template #selected-option="option">
          <span
            v-if="
              evaluator_view &&
              actualTest &&
              startTest(option.id) &&
              !finishTest(option.id) &&
              !isPublichGradeStudent(option.id) &&
              !isDateAfterTest(actualTest.end_time)
            "
          >
            🟡
          </span>
          <span
            v-if="
              evaluator_view &&
              actualTest &&
              startTest(option.id) &&
              !finishTest(option.id) &&
              !isPublichGradeStudent(option.id) &&
              isDateAfterTest(actualTest.end_time)
            "
          >
            🟠
          </span>
          <span
            v-if="
              actualTest &&
              evaluator_view &&
              finishTest(option.id) &&
              !isPublichGradeStudent(option.id)
            "
          >
            🟢
          </span>
          <span
            v-if="
              actualTest && evaluator_view && isPublichGradeStudent(option.id)
            "
            class="checkmark"
          >
            📝
          </span>
          <span v-if="actualTest && evaluator_view && !startTest(option.id)">
            ❌
          </span>
          <span v-if="actualTest && evaluator_view && inGroup(option.id)">
            {{ getNameGroup(option.id) }}
            <span v-if="isLeaderStudent(option.id)">🚩 </span>
            -
          </span>
          {{ option.display_name }}
        </template>
      </v-select>
      <InfoModal
        v-if="evaluator_view && actualTest"
        class="ml-1 noprint"
        :tooltip_text="$t('evaluations.newEvaluations.pressToViewIconLegend')"
        :modal_title="$t('evaluations.newEvaluations.evaluateeIconLegend')"
      >
        <b-table-simple bordered striped>
          <b-thead>
            <b-tr>
              <b-th class="primary-cell">{{
                $t("evaluations.newEvaluations.information")
              }}</b-th>
              <b-th class="primary-cell text-center">{{
                $t("evaluations.newEvaluations.icon")
              }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>{{
                $t("evaluations.newEvaluations.evaluateeStartedEvaluation", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    false,
                    "Evaluación"
                  ),
                })
              }}</b-td>
              <b-td class="text-center">🟡</b-td>
            </b-tr>
            <b-tr>
              <b-td>{{
                $t(
                  "evaluations.newEvaluations.evaluateeStartedButNotFinished",
                  {
                    entity: $getVisibleNames(
                      "evaluations2.evaluation",
                      false,
                      "Evaluación"
                    ),
                  }
                )
              }}</b-td>
              <b-td class="text-center">🟠</b-td>
            </b-tr>
            <b-tr>
              <b-td>{{
                $t("evaluations.newEvaluations.evaluateeFinishedEvaluation", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    false,
                    "Evaluación"
                  ),
                })
              }}</b-td>
              <b-td class="text-center">🟢</b-td>
            </b-tr>
            <b-tr>
              <b-td>{{
                $t("evaluations.newEvaluations.evaluateeNotStarted", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    false,
                    "Evaluación"
                  ),
                })
              }}</b-td>
              <b-td class="text-center">❌</b-td>
            </b-tr>
            <b-tr>
              <b-td>{{
                $t("evaluations.newEvaluations.evaluateeGradePublished")
              }}</b-td>
              <b-td class="text-center">📝</b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ $t("evaluations.newEvaluations.groupLeader") }}</b-td>
              <b-td class="text-center">🚩</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </InfoModal>
      <b-form-select
        v-model="sort_by"
        size="sm"
        class="ml-2"
        style="width: auto"
      >
        <b-form-select-option value="first_name">
          {{ $t("evaluations.newEvaluations.sortByFirstName") }}
        </b-form-select-option>
        <b-form-select-option value="last_name">
          {{ $t("evaluations.newEvaluations.sortByLastName") }}
        </b-form-select-option>
      </b-form-select>
    </div>
    <div class="navigate-items w-25">
      <template v-if="students.length > 0">
        <b-button
          v-if="skip_corrected && availableUnPublished"
          size="sm"
          variant="primary"
          :disabled="!availablePreviousUserUnCorected"
          @click="previousUserUnCorrected"
          v-b-tooltip.v-secondary.noninteractive="
            $t('evaluations.newEvaluations.previousUncorrected')
          "
          class="ml-2 navigate-left"
          :class="{
            'navigate-left-sticky': sticky,
            'navigate-color': availablePreviousUserUnCorected,
          }"
        >
          <b-icon icon="chevron-double-left"></b-icon>
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="previousUser"
          v-b-tooltip.v-secondary.noninteractive="
            $t('evaluations.newEvaluations.goToPrevious')
          "
          class="navigate-left navigate-color"
          :class="{
            'navigate-left-sticky': sticky,
            'ml-2': !skip_corrected || !availableUnPublished,
          }"
        >
          <b-icon icon="chevron-left"></b-icon>
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          v-b-tooltip.v-secondary.noninteractive="
            $t('evaluations.newEvaluations.goToNext')
          "
          @click="nextUser"
          class="navigate-right navigate-color"
          :class="{
            'navigate-right-sticky': sticky,
            'mr-2': !skip_corrected || !availableUnPublished,
          }"
        >
          <b-icon icon="chevron-right"></b-icon>
        </b-button>
        <b-button
          v-if="skip_corrected && availableUnPublished"
          size="sm"
          :disabled="!availableNextUserUnCorected"
          variant="primary"
          @click="nextUserUnCorrected"
          v-b-tooltip.v-secondary.noninteractive="
            $t('evaluations.newEvaluations.nextUncorrected')
          "
          class="navigate-right mr-2"
          :class="{
            'navigate-right-sticky': sticky,
            'navigate-color': availableNextUserUnCorected,
          }"
        >
          <b-icon icon="chevron-double-right"></b-icon>
        </b-button>
      </template>
      <template v-else
        ><b-badge class="badge-no-student ml-2 mr-2" variant="danger">{{
          $t("evaluations.newEvaluations.noStudentsSelected")
        }}</b-badge></template
      >
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import vSelect from "vue-select";

export default {
  name: "EvaluateeCarousel",
  components: {
    InfoModal: () => import("@/components/reusable/InfoModal"),
    "v-select": vSelect,
  },
  props: {
    section_id: {
      type: Number,
    },
    current_users: {
      type: Array,
    },
    sticky: {
      type: Boolean,
    },
    actualTest: {
      type: Object,
    },
    skip_corrected: {
      type: Boolean,
      default: false,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected_student_id: null,
      sort_by: "first_name",
    };
  },
  computed: {
    ...mapGetters({
      sections: names.SECTIONS,
      users: names.USERS,
      evaluatee_tests: names.EVALUATEE_TESTS,
      new_test_groups: names.NEW_TEST_GROUPS,
    }),
    currentNewTestGroups() {
      if (this.actualTest) {
        return this.new_test_groups.filter(
          (x) => x.test === this.actualTest.id
        );
      } else return [];
    },
    section() {
      if (!this.section_id) return [];
      return this.sections.find((x) => x.id == this.section_id);
    },
    students() {
      let list = [];
      if (!this.section_id) {
        if (this.current_users) {
          list = this.users.filter((x) => this.current_users.includes(x.id));
        }
      } else if (this.section) {
        list = this.section.students_detail || [];
      }
      // Se copia antes de ordenar: students_detail es una referencia al store
      return [...list].sort((a, b) => {
        const fieldA = a[this.sort_by] || "";
        const fieldB = b[this.sort_by] || "";
        return fieldA.localeCompare(fieldB);
      });
    },
    studentsFormatted() {
      return this.students.map((student) => ({
        id: student.id,
        display_name: student.first_name + " " + student.last_name,
        ...student,
      }));
    },
    availableNextUserUnCorected() {
      if (this.selected_student_id == null && this.students.length > 0)
        return true;
      const current_index = this.students.findIndex(
        (x) => x.id == this.selected_student_id
      );
      if (
        this.students.some((x, index) => {
          if (index > current_index)
            if (!this.isPublichGradeStudent(x.id)) return true;
        })
      )
        return true;
      else return false;
    },
    availablePreviousUserUnCorected() {
      if (this.selected_student_id == null && this.students.length > 0)
        return true;
      const current_index = this.students.findIndex(
        (x) => x.id == this.selected_student_id
      );
      if (
        this.students.some((x, index) => {
          if (index < current_index)
            if (!this.isPublichGradeStudent(x.id)) return true;
        })
      )
        return true;
      else return false;
    },
    availableUnPublished() {
      if (!this.actualTest) return false;
      const students_ids = this.students.map((x) => x.id);
      return this.evaluatee_tests.some(
        (x) =>
          x.test === this.actualTest.id &&
          students_ids.includes(x.evaluatee) &&
          x.is_published == false
      );
    },
  },
  methods: {
    isDateAfterTest(end_time) {
      const now = new this.$moment();
      const endDateTest = this.$moment(end_time);

      return now.isAfter(endDateTest);
    },
    isPublichGradeStudent(user_id) {
      if (!this.actualTest) return false;
      return this.evaluatee_tests.some(
        (x) =>
          x.test === this.actualTest.id &&
          x.evaluatee == user_id &&
          x.is_published == true
      );
    },
    startTest(user_id) {
      if (!this.actualTest) return false;
      return this.evaluatee_tests.some(
        (x) =>
          x.test == this.actualTest.id &&
          x.evaluatee == user_id &&
          x.start_time != null
      );
    },
    finishTest(user_id) {
      if (!this.actualTest) return false;
      return this.evaluatee_tests.some(
        (x) =>
          x.test == this.actualTest.id &&
          x.evaluatee == user_id &&
          x.finished_at
      );
    },
    inGroup(user_id) {
      if (!this.actualTest) return false;
      return this.currentNewTestGroups.some((x) =>
        x.students.includes(user_id)
      );
    },
    isLeaderStudent(user_id) {
      if (!this.actualTest) return false;
      return this.currentNewTestGroups.some((x) => x.leader == user_id);
    },
    getNameGroup(user_id) {
      if (!this.actualTest) return false;
      const test_group = this.currentNewTestGroups.find((x) =>
        x.students.includes(user_id)
      );
      return test_group ? test_group.name : "";
    },
    previousUser() {
      if (this.students.length == 0) return;
      if (!this.selected_student_id) {
        this.selected_student_id = this.students[this.students.length - 1].id;
        return;
      }
      const index = this.students.findIndex(
        (x) => x.id == this.selected_student_id
      );
      if (index != -1 && index == 0) {
        this.selected_student_id = this.students[this.students.length - 1].id;
        return;
      } else if (this.students.length > 0) {
        this.selected_student_id = this.students[index - 1].id;
        return;
      }
    },
    nextUser() {
      if (this.students.length == 0) return;
      if (!this.selected_student_id && this.students.length > 0) {
        this.selected_student_id = this.students[0].id;
        return;
      }
      const index = this.students.findIndex(
        (x) => x.id == this.selected_student_id
      );
      if (index != -1 && index < this.students.length - 1) {
        this.selected_student_id = this.students[index + 1].id;
        return;
      } else if (this.students.length > 0) {
        this.selected_student_id = this.students[0].id;
        return;
      }
    },
    nextUserUnCorrected() {
      if (this.students.length == 0 && this.availableNextUserUnCorected) return;
      if (!this.selected_student_id && this.students.length > 0) {
        this.selected_student_id = this.students[0].id;
        return;
      }
      const index = this.students.findIndex(
        (x) => x.id == this.selected_student_id
      );
      if (index != -1 && index < this.students.length - 1) {
        for (let i = index + 1; i < this.students.length; i++) {
          if (
            this.students[i] &&
            !this.isPublichGradeStudent(this.students[i].id)
          ) {
            this.selected_student_id = this.students[i].id;
            return;
          }
          if (i + 1 == this.students.length) {
            this.selected_student_id = this.students[0].id;
            return;
          }
        }
      } else if (this.students.length > 0) {
        this.selected_student_id = this.students[0].id;
        return;
      }
    },
    previousUserUnCorrected() {
      if (this.students.length == 0) return;
      if (!this.selected_student_id) {
        this.selected_student_id = this.students[this.students.length - 1].id;
        return;
      }
      const index = this.students.findIndex(
        (x) => x.id == this.selected_student_id
      );
      if (index != -1 && index == 0) {
        this.selected_student_id = this.students[this.students.length - 1].id;
        return;
      } else if (this.students.length > 0) {
        for (let i = index - 1; i >= 0; i--) {
          if (
            this.students[i] &&
            !this.isPublichGradeStudent(this.students[i].id)
          ) {
            this.selected_student_id = this.students[i].id;
            return;
          }
        }
      }
    },
  },
  watch: {
    selected_student_id() {
      this.$emit("student_selcted", this.selected_student_id);
    },
  },
  created() {
    if (this.section_id) {
      // Los estudiantes vienen anidados en la sección, sin pasar por el endpoint de usuarios
      this.$store.dispatch(names.FETCH_SECTION, {
        section_id: this.section_id,
        expand: ["students"],
      });
    }
    // current_users recibe listas que no son la nómina de una sección (evaluados de v2)
    if (this.current_users) {
      // this.selected_student_id = this.current_users[0];
      this.$store.dispatch(names.FETCH_ALT_USERS, {
        user_ids: this.current_users,
      });
    }
  },
};
</script>

<style scoped>
.primary-cell {
  align-items: center;
  background-color: var(--kl-color-accent-medium) !important;
  color: white;
  font-weight: bold;
  vertical-align: middle;
}
.checkmark {
  color: green;
  font-size: 18px; /* Ajusta el tamaño según sea necesario */
}
.badge-no-student {
  display: flex;
  align-items: center;
}
.select-container {
  width: 100%;
  align-items: center !important; 
}
.navigate-left,
.navigate-left-sticky,
.navigate-right,
.navigate-right-sticky {
  color: #fff;
}
.navigate-items {
  display: flex;
}

.navigate-left,
.navigate-right {
  width: 100%;
}
.navigate-left {
  margin-right: 0.5em;
}
.navigate-right {
  margin-left: 0.5em;
}

.navigate-left-sticky,
.navigate-right-sticky {
  width: 100%;
}

/* v-select small size styling */
.v-select-sm >>> .vs__dropdown-toggle {
  min-height: 31px;
  padding: 0;
}
.v-select-sm >>> .vs__search,
.v-select-sm >>> .vs__selected {
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 2px 0;
  padding: 0 0.25rem;
}
.v-select-sm >>> .vs__actions {
  padding: 2px 6px;
}
.v-select-sm >>> .vs__clear,
.v-select-sm >>> .vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
}

/* Dropdown menu styling */
.v-select-sm >>> .vs__dropdown-menu {
  background: #fff;
  color: #333;
  z-index: 9999;
}
.v-select-sm >>> .vs__dropdown-option {
  color: #333;
  background: #fff;
}
.v-select-sm >>> .vs__dropdown-option--highlight {
  background: #5897fb;
  color: #fff;
}
.v-select-sm >>> .vs__dropdown-option--selected {
  background: #f0f0f0;
  color: #333;
}

/* Placeholder styling */
.v-select-sm >>> .vs__search::placeholder {
  color: #6c757d;
}
.v-select-sm >>> .vs__selected {
  color: #333;
}

@media (max-width: 991px) {
  .student-carousel-sticky > .select-container {
    width: 80%;
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
}
</style>